<template>
  <div>
    <a-spin :spinning="isLoading">
      <ls-api-table
        ref="dataTable"
        :columns="columns"
        :tableProps="tableProps"
        rowKey="id"
        :scroll="{ x: 1300, y:cusHeight}"
      >
        <template slot="deliveryDate2" slot-scope="{ record }">
          <a-tooltip>
            <template slot="title">
              <span >{{ record.deliveryDate }}</span>
            </template>
            <span >{{ record.deliveryDate }}</span>
          </a-tooltip>
        </template>
      </ls-api-table>
    </a-spin>
  </div>
</template>
<script>
import { generateLsTableResData } from '@/utils/util.js';
import { worklistSearch } from "@/api/scp/productionScheduling/schedulingWorkbench.js"

export default {
  name: 'SchedulingInfoTable',
  props: {
    cusHeight: {
      type: Number,
      default: 300
    },
    queryParams: {
      type: Object,
      default: () => {}
    }
  },
  mounted () {
    this.$refs.dataTable.myPagination.pageSizeOptions = ["5", "10", "20"]
    this.$refs.dataTable.myPagination.pageSize = 10
  },
  components: {
  },
  data () {
    // 查询参数
    return {
      isLoading: false,
      // 表格字段
      columns: [
        {
          title: '公司主体',
          width: 180,
          ellipsis: true,
          fixed: 'left',
          dataIndex: 'supplierName',
          align: 'center'
        },
        {
          title: '库存组织',
          dataIndex: 'orgName',
          width: 120,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '产线',
          width: 120,
          dataIndex: 'lineCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '计划单号',
          width: 120,
          dataIndex: 'orderNo',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '需求时间',
          width: 120,
          dataIndex: 'deliveryDate2',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'deliveryDate2' }
        },
        {
          title: '物料编码',
          width: 120,
          dataIndex: 'itemCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '物料名称',
          width: 120,
          dataIndex: 'itemName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '规格描述',
          width: 120,
          dataIndex: 'description',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '物料类型',
          width: 120,
          dataIndex: 'itemTypeDesc',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '单位',
          width: 120,
          dataIndex: 'primaryUom',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '瓶颈节拍',
          width: 120,
          dataIndex: 'workshopDesc',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '需求数量',
          width: 120,
          dataIndex: 'orderQuantity',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '交货时间',
          width: 120,
          dataIndex: 'deliveryDate',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '开始时间',
          width: 120,
          dataIndex: 'startDate',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '结束时间',
          width: 120,
          dataIndex: 'completionDate',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '工单号',
          width: 120,
          dataIndex: 'wipEntityName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '工单类型',
          width: 120,
          dataIndex: 'jobTypeDesc',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '工单状态',
          width: 120,
          dataIndex: 'statusDesc',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '备注',
          width: 120,
          dataIndex: 'remarks',
          ellipsis: true,
          align: 'center'
        }
      ],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(worklistSearch, true),
        pageCurrent: true
      },
      tableList: []
    }
  },
  methods: {
    getData () {
      console.log(this.queryParams)
      this.$refs.dataTable.searchParams = {
        orgNo: this.queryParams.orgNo,
        vendorCode: this.queryParams.vendorCode,
        startDate: this.queryParams.startDate1,
        endDate: this.queryParams.startDate2
      };
      this.isLoading = true
      worklistSearch({
        orgNo: this.queryParams.orgNo,
        vendorCode: this.queryParams.vendorCode,
        startDate: this.queryParams.startDate1,
        endDate: this.queryParams.startDate2,
        pageSize: this.$refs.dataTable.myPagination.pageSize,
        pageNum: 1
      }).then(response => {
        this.isLoading = false
        if (response.code === 200) {
          this.tableList = response.rows
          this.$refs.dataTable.myDataSource = this.tableList
          this.$refs.dataTable.myPagination.total = Number(response?.total || 0)
          this.$refs.dataTable.pageTotal = Number(this.$refs.dataTable.getPageTotal(Number(response?.total || 0), this.$refs.dataTable.myPagination.pageSize))
        } else {
          this.$message.error(response.msg)
        }
      })
    }
  }
}
</script>
